import { Injectable } from '@angular/core';
import sdk from 'src/.cobalt/sdk';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root', // Or scope to the module (see below)
})
export class CobaltSdkService {
	public sdk = sdk;

	constructor() {
		// Automatically call initialize when the service is instantiated
		this.initialize();
	}

	initialize() {
		sdk.init({
			fetcher: (input, init) => {
				return fetch(environment.bffEndpoint, init);
			},
		});
	}
}
